import React from 'react'

import { cn } from '@/lib/utils'

export function CompactMetricsGrid({
  children,
  className,
}: {
  children: React.ReactNode
  className?: string
}) {
  return <div className={cn('nm-mobile-simple__metrics-compact', className)}>{children}</div>
}

export function CompactMetricCell({
  label,
  value,
  accent,
}: {
  label: string
  value: React.ReactNode
  accent?: boolean
}) {
  return (
    <div className={cn('nm-mobile-simple__metric-cell', accent && 'nm-mobile-simple__metric-cell--accent')}>
      <span className="nm-mobile-simple__metric-cell-label">{label}</span>
      <span className="nm-mobile-simple__metric-cell-value">{value}</span>
    </div>
  )
}

export function MetricsDetailCard({ title, children }: { title?: string; children: React.ReactNode }) {
  return (
    <div className="nm-mobile-simple__metrics-panel">
      {title ? <p className="nm-mobile-simple__metrics-title">{title}</p> : null}
      <div className="nm-mobile-simple__review-card">
        <dl>{children}</dl>
      </div>
    </div>
  )
}

export function MetricDetailRow({ label, value }: { label: string; value: React.ReactNode }) {
  return (
    <div className="nm-mobile-simple__review-row">
      <dt>{label}</dt>
      <dd>{value}</dd>
    </div>
  )
}
